import { ACTIONS, setLanguageState } from '../Constants';

const getInitialState = () => ({
    languageCode: 'en',
    messages: {},
    languageLoaded: false
});

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case ACTIONS.CHANGE_LANGUAGE: {
            const { languageCode, messages, languageLoaded } = action.payload;
            const newState = {
                languageCode,
                messages,
                languageLoaded
            };
            setLanguageState(newState);
            return newState;
        }
        default:
            return state;
    }
};
